import React from 'react';

const AffiliateContext = React.createContext({});

export default AffiliateContext;
